import { defineStore } from "pinia";
import axios from 'axios';
import { handleError } from "./storeHelper";
import { ref } from "vue";
import type { Role } from "@/types";

export const useRoleStore = defineStore('roleStore', () => {
    const apiUrl = "api/v1/role";


    const isLoading = ref<boolean>(false);
    const items = ref<Role[]>();


    const list = async () => {

        try {
            isLoading.value = true;
            const response = await axios.get<Role[]>(apiUrl, {
            });
            items.value = response.data;
        }
        catch (error) {
            handleError(error);
            throw error;
        }
        finally {
            isLoading.value = false;
        }
    }

    return { list, items, loading: isLoading }
})